module.exports = __webpack_public_path__ + "../resources/img/ic_add_module_default.e557bc98.svg";